import React from "react";
import { SimpleShowLayout, TextField } from "react-admin";

const Tab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="soccer.id" />
      <TextField source="soccer.playerGameCount" />
      <TextField source="soccer.totalGoals" />
      <TextField source="soccer.assists" />
      <TextField source="soccer.shutouts" />
    </SimpleShowLayout>
  );
};

export default Tab;
